import * as Config from 'Config/authenticated';
import bootstrap from './bootstrap';

bootstrap(Config);